const EMBED = 'https://www.youtube-nocookie.com/embed/';

function play(root: HTMLElement): void {
	const id = root.dataset.videoId;

	if (!id) {
		return;
	}

	const frame = document.createElement('iframe');
	frame.src = `${EMBED}${id}?autoplay=1&rel=0`;
	frame.title = root.querySelector('.screen-reader-text')?.textContent?.trim() || 'YouTube';
	frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
	frame.setAttribute('allowfullscreen', '');
	frame.loading = 'lazy';
	frame.style.cssText = 'display:block;width:100%;height:100%;aspect-ratio:16/9;border:0';

	root.replaceChildren(frame);
	frame.focus();
}

// Not every video has a maxresdefault thumbnail; hqdefault always exists.
function fixThumb(image: HTMLImageElement): void {
	if (image.src.indexOf('maxresdefault') === -1) {
		return;
	}

	image.src = image.src.replace('maxresdefault', 'hqdefault');
	image.classList.add('is-fallback');
}

function watchThumbs(): void {
	document.querySelectorAll<HTMLImageElement>('[data-armada-video] img').forEach((image) => {
		if (image.complete && image.naturalWidth === 0) {
			fixThumb(image);

			return;
		}

		image.addEventListener('error', () => fixThumb(image), { once: true });
	});
}

export default function initVideoEmbeds(): void {
	watchThumbs();

	document.querySelectorAll<HTMLElement>('[data-armada-video]').forEach((root) => {
		root.addEventListener('click', (event) => {
			if ((event.target as HTMLElement).closest('button')) {
				event.preventDefault();
				play(root);
			}
		});
	});
}
